export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const LOAD_SHOWS = "LOAD_SHOWS";
export const LOAD_SHOWS_WITH_VENUES = "LOAD_SHOWS_WITH_VENUES";
export const LOAD_SONGS = "LOAD_SONGS";
export const LOAD_ALBUMS = "LOAD_ALBUMS";
export const LOAD_VENUES = "LOAD_VENUES";
export const ADD_SHOW = "ADD_SHOW";
export const ADD_SONG = "ADD_SONG";
export const ADD_ALBUM = "ADD_ALBUM";
export const DELETE_SHOW = "DELETE_SHOW"
export const DELETE_SHOWS_WITH_VENUE = "DELETE_SHOWS_WITH_VENUE";
export const DELETE_ALBUM = "DELETE_ALBUM";
export const DELETE_SONG = "DELETE_SONG";
export const UPDATE_SHOW = "UPDATE_SHOW";
export const UPDATE_SONG = "UPDATE_SONG";
export const UPDATE_ALBUM = "UPDATE_ALBUM";